import { useEffect } from "react";
import confetti from "canvas-confetti";
import { Award } from "lucide-react";
import { useLang } from "@/i18n";
import { CHALLENGES } from "@/game/config";

// Celebratory popup for completing a story challenge (character + level badge).
export default function BadgeModal({ badge, onClose }) {
  const { t } = useLang();
  const ch = CHALLENGES.find((c) => c.id === badge?.id);
  const name = ch ? t(ch.nameKey) : (badge?.name || "");
  const emoji = badge?.badge || ch?.badge || "🏅";

  useEffect(() => {
    const colors = ["#FFD400", "#E91E63", "#0067C6", "#4CAF50"];
    const fire = () => {
      confetti({ particleCount: 80, spread: 100, origin: { x: 0.5, y: 0.4 }, colors });
    };
    fire();
    const iv = setInterval(fire, 1200);
    const stop = setTimeout(() => clearInterval(iv), 4200);
    return () => { clearInterval(iv); clearTimeout(stop); };
  }, []);

  return (
    <div className="fixed inset-0 z-[130] bg-black/85 overflow-y-auto overscroll-contain flex items-start justify-center p-4"
      onClick={onClose} data-testid="badge-modal-overlay">
      <div className="pixel-card bg-[#141414] w-full max-w-sm my-8 max-h-full text-center nb-pop p-5"
        onClick={(e) => e.stopPropagation()} data-testid="badge-modal">
        <p className="font-pixel text-[10px] text-[#FFD400] pixel-stroke flex items-center justify-center gap-1.5 mb-2">
          <Award size={14} strokeWidth={2.5} /> {t("storyChallenges")}
        </p>
        <h2 className="font-pixel text-base md:text-xl text-[#FFD400] pixel-stroke leading-tight" data-testid="badge-title">
          {t("badgeEarnedTitle")}
        </h2>
        <div className="my-4 flex justify-center">
          <div className="w-28 h-28 rounded-full flex items-center justify-center text-6xl nb-dance"
            style={{ background: `radial-gradient(circle at 40% 35%, ${ch?.color || "#3a8fe0"}, #0c0c14)`, boxShadow: `0 0 26px ${ch?.color || "#3a8fe0"}` }}>
            {emoji}
          </div>
        </div>
        <p className="font-vt text-lg text-white/90 leading-snug px-2" data-testid="badge-body">
          {t("badgeEarnedBody")(name)}
        </p>
        <button data-testid="badge-close-btn" onClick={onClose}
          className="pixel-btn bg-[#4CAF50] text-white w-full px-6 py-3 text-sm mt-4 blink">
          {t("badgeEarnedCta")}
        </button>
      </div>
    </div>
  );
}
